module.exports = __webpack_public_path__ + "static/media/ic-plus.095a9e21.svg";